import React, { useCallback, useEffect, useState } from 'react'
import { Table, Tabs } from 'components'
import { WrapDataGrid } from 'components/DataGrid/Style'
import { initialPage, initialPageSize } from 'keys/pagination'
import { dataGridModel, queryClient as qc } from 'keys'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { LightButton, TablePageStyles, WrapHeader } from 'styles/GlobalStyle'
import { ticketHooks } from '.'
import { getTicketsFetch } from 'store/middlewares/tickets.crud'
import { Button } from 'components/Form'
import { TicketsHeader, TabsDivider, WrapTabs, TicketsStyles } from './Style'
import { Divider } from '@mui/material'

const Tickets = () => {
    const [page, setPage] = useState(initialPage)
    const [pageSize, setPageSize] = useState(initialPageSize)
    const [sorting, setSorting] = useState([])
    const [searchVal, setSearchVal] = useState("")
    const [selectedTab, setSelectedTab] = useState(0)

    const columns = ticketHooks.useColumns()
    const tabs = ticketHooks.useTabs()
    const headerBtns = ticketHooks.useHeaderBtns()

    const ticketOptions = queryOptions({
        queryKey: [qc.tickets, page, pageSize, sorting, selectedTab, searchVal],
        queryFn: async () => {
            const { data } = await getTicketsFetch({ page, pageSize, sorting, search: searchVal, model: qc.tickets, ticket_type: tabs[selectedTab].id })
            return data
        }
    })
    const tickets = useQuery(ticketOptions)

    const handleTab = useCallback((index) => {
        setSelectedTab(index)
    }, [])

    useEffect(() => {
        tickets.refetch()
    }, [])

    return (
        <TicketsStyles>
            <WrapTabs>
                <WrapHeader withTabs>
                    <TicketsHeader>
                        <Tabs hideBorder tabs={tabs} handleTab={handleTab} />
                        {headerBtns.map((btn) =>
                            <Button {...btn} />
                        )}
                    </TicketsHeader>
                </WrapHeader>
                <div className='wrap-divider'>
                    <Divider className='divider2' />
                </div>
            </WrapTabs>
            <TablePageStyles hideSpace>
                <Table
                    loading={tickets.isFetching && !tickets.data}
                    data={tickets.data}
                    visibilityModelKey={dataGridModel.tickets}
                    page={page}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    columns={columns}
                    setPage={setPage}
                    searchVal={searchVal}
                    setSearchVal={setSearchVal}
                    sorting={sorting}
                    setSorting={setSorting}
                    queryKey={ticketOptions.queryKey}
                />
            </TablePageStyles>
        </TicketsStyles >
    )
}

export default Tickets
